export var IdLeagues;
(function (IdLeagues) {
    IdLeagues[IdLeagues["Bronze1"] = 0] = "Bronze1";
    IdLeagues[IdLeagues["Bronze2"] = 1] = "Bronze2";
    IdLeagues[IdLeagues["Bronze3"] = 2] = "Bronze3";
    IdLeagues[IdLeagues["Silver1"] = 3] = "Silver1";
    IdLeagues[IdLeagues["Silver2"] = 4] = "Silver2";
    IdLeagues[IdLeagues["Silver3"] = 5] = "Silver3";
    IdLeagues[IdLeagues["Gold1"] = 6] = "Gold1";
    IdLeagues[IdLeagues["Gold2"] = 7] = "Gold2";
    IdLeagues[IdLeagues["Gold3"] = 8] = "Gold3";
    IdLeagues[IdLeagues["Emerald1"] = 9] = "Emerald1";
    IdLeagues[IdLeagues["Emerald2"] = 10] = "Emerald2";
    IdLeagues[IdLeagues["Emerald3"] = 11] = "Emerald3";
    IdLeagues[IdLeagues["Sapphire1"] = 12] = "Sapphire1";
    IdLeagues[IdLeagues["Sapphire2"] = 13] = "Sapphire2";
    IdLeagues[IdLeagues["Sapphire3"] = 14] = "Sapphire3";
})(IdLeagues || (IdLeagues = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdLeagues.ts
// module id = 365
// module chunks = 3